import type { DeepStringLike, MergeLiteralObjects } from "./types";

export const tasksStringsEn = {
  assessQaResults: {
    opsOnly: "QA results are reviewed by the Remi operations team.",
    coveredStatus: {
      decided: "Decided",
      awaitingChecklist: "Awaiting checklist",
      awaitingDecision: "Awaiting decision",
    },
    revisit: {
      title: "Request additional photos",
      description:
        "This checklist goes back to the inspector, and the visit's photo upload task reopens until they resubmit it.",
      reasonLabel: "Please explain what photos are needed.",
      reasonPlaceholder: "What photos are needed?",
      confirmButton: "Send request",
    },
  },
  reviewAndAcceptWorkOrder: {
    heading: "Are you sure you want to reject the work order?",
    description: "By declining the work order, you are declining the opportunity to perform the work for this project.",
    messagePlaceholder: "Reason for declining",
    confirmButton: "Reject work order",
    confirmationMessage:
      "By accepting this job, you agree to the scope of work and pricing terms outlined on the work order. If there is additional scope that is discovered for the project, a change order must be submitted and approved by Remi for the associated costs. Please submit change orders as soon as possible.",
  },
} as const;

type TasksStringsEn = typeof tasksStringsEn;

export const tasksStringsEs = {
  assessQaResults: {
    opsOnly: "El equipo de operaciones de Remi revisa los resultados de QA.",
    coveredStatus: {
      decided: "Decidido",
      awaitingChecklist: "Esperando la lista de verificación",
      awaitingDecision: "Esperando decisión",
    },
    revisit: {
      title: "Solicitar fotos adicionales",
      description:
        "Esta lista de verificación vuelve al inspector, y la tarea de subir fotos de la visita se reabre hasta que la vuelva a enviar.",
      reasonLabel: "Explica qué fotos se necesitan.",
      reasonPlaceholder: "¿Qué fotos se necesitan?",
      confirmButton: "Enviar solicitud",
    },
  },
  reviewAndAcceptWorkOrder: {
    heading: "Are you sure you want to reject the work order?",
    description: "By declining the work order, you are declining the opportunity to perform the work for this project.",
    messagePlaceholder: "Reason for declining",
    confirmButton: "Reject work order",
    confirmationMessage:
      "By accepting this job, you agree to the scope of work and pricing terms outlined on the work order. If there is additional scope that is discovered for the project, a change order must be submitted and approved by Remi for the associated costs. Please submit change orders as soon as possible.",
  },
} as const satisfies DeepStringLike<TasksStringsEn>;

type TasksStringsEs = typeof tasksStringsEs;

export type TasksStrings = MergeLiteralObjects<TasksStringsEn, TasksStringsEs>;
